import { ImmersiveScrollBlock as ImmersiveScrollBlockSDS } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';

import { renderRichTextMultiLineWithMarkings } from '../../utils/renderText/renderRichText';
import { ImmersiveScrollBlockCard } from './ImmersiveScrollBlockCard';
import type { ImmersiveScrollBlockDataProps } from './types';

export const ImmersiveScrollBlock: FC<ImmersiveScrollBlockDataProps> = props => {
  const {
    title,
    tilesDirection,
    text,
    textAlignmentMobile,
    eyebrow,
    backgroundColor,
    anchor,
    tilesCollection,
  } = props;

  return (
    <ImmersiveScrollBlockSDS
      title={renderRichTextMultiLineWithMarkings(title)}
      eyebrow={eyebrow}
      tilesDirection={tilesDirection}
      text={text}
      textAlignmentMobile={textAlignmentMobile}
      backgroundColor={backgroundColor}
      anchor={anchor}
    >
      {tilesCollection.items.map(tile => ImmersiveScrollBlockCard(tile))}
    </ImmersiveScrollBlockSDS>
  );
};

ImmersiveScrollBlock.displayName = 'ImmersiveScrollBlock';
